import { Link } from 'react-router-dom'

// Keep old bookmarks useful without mounting legacy charts, autosave or backtests.
// Do not redirect legacy record IDs into QCP: they identify different projects.
export default function RetiredStrategyWorkspace() {
  return (
    <section className="px-6 py-5 max-w-screen-xl mx-auto">
      <h1 className="text-2xl font-bold text-ink">Legacy Strategy Workspace retired</h1>
      <p className="text-sm text-inkMuted mt-3 max-w-xl">
        Editing, live charts, and backtests in this workspace are no longer available.
        Your saved strategies, versions, and results are preserved.
      </p>
      <p className="text-sm text-inkMuted mt-3 max-w-xl">
        The QCP Strategy Workspace is separate. Retiring this page does not change
        your QCP projects or notebooks.
      </p>
      <Link to="/strategies" className="inline-block mt-5 text-sm font-semibold text-ink underline">
        Back to strategies
      </Link>
    </section>
  )
}
